import { get } from 'svelte/store'
import { navigate, type RouteFunction } from '$classes/Router'
import { ensurePartner, ensureUser, ensureAdmin } from '$lib/services/boot'
import { partnerStore } from '$lib/stores/partner.store'

export const isLogged: RouteFunction = async (_a, next) => {
    const user = await ensureUser()
    if (!user) return navigate('/login')
    next()
}

export const isAdmin: RouteFunction = async (_a, next) => {
    const admin = await ensureAdmin()
    if (!admin) return navigate('/backoffice/login')
    next()
}

export const reverseAuth: RouteFunction = async (_a, next) => {
    const user = await ensureUser({ silent: true })
    if (user) return navigate('/')
    next()
}

export const reverseAdmin: RouteFunction = async (_a, next) => {
    const admin = await ensureAdmin({ silent: true })
    if (admin) return navigate('/backoffice')
    next()
}

export const partnerBoot: RouteFunction = async (activeRoute, next) => {
    await ensurePartner()
    const partner = get(partnerStore)
    if (!partner) return next()
    if (
        partner.maintenance &&
        !activeRoute.path.startsWith('/maintenance') &&
        !activeRoute.path.includes('backoffice')
    ) {
        return navigate('/maintenance')
    }
    if (activeRoute.path === '/maintenance' && !partner.maintenance) {
        return navigate('/')
    }
    next()
}
